<template>
  <div class="rtsp overFlowXauto">
    <div class="left-tree">
      <Tree
        @changeSwitch="changeSwitch"
        :switchVal="switchVal"
        @nodeClick="nodeClick"
      ></Tree>
    </div>
    <div class="right-content">
      <TabelSearch
        :searchConfig="searchConfig"
        :searchParams="searchParams"
        @resetCallBack="resetCallBack"
        @search="startSearch"
      ></TabelSearch>
      <Table
        :width="'100%'"
        :tableLoading="tableLoading"
        :tabelButtons="tabelButtons"
        :templateData="tableTemplateData"
        :tableConfig="tableConfig"
        :pagination="pagination"
      ></Table>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <editForm
        ref="editForm"
        :formConfig="formConfig"
        :ruleForm="ruleForm"
        :rules="rules"
        :buttonConfig="buttonConfig"
      ></editForm>
    </el-dialog>
  </div>
</template>
<script>
import Tree from "../../../../components/Tree/nodeTree";
import TabelSearch from "../../../../components/tabel-search/tabel-search";
import { systemApi } from "../../../../api-path/system-api.js";
export default {
  name: "allUsers",
  components: {
    Tree,
    TabelSearch,
  },
  data() {
    return {
      switchVal: false,
      isEdit: false,
      title: "",
      searchConfig: {
        dataName: "searchParams",
        items: [
          {
            key: "search",
            valueType: "text",
            placeholder: "请输入名称/唯一码",
          },
        ],
      },
      searchParams: {
        areaId: "",
        isDown: "",
        search: "",
        page: 1,
        size: 15,
      },
      tableLoading: false,
      tabelButtons: [
        {
          type: "add",
          fn: () => {
            this.title = "新增";
            this.isEdit = false;
            this.ruleForm = {
              areaId: this.areaId,
              id: "",
              name: "",
              phoneUrl: "",
              rtspKey: "",
              stbUrl: "",
            };
            this.dialogVisible = true;
          },
        },
      ],
      dialogVisible: false,
      tableTemplateData: [],
      tableConfig: {
        checkbox: true,
        checkboxFn: (data) => {
          console.log(data);
        },
        rows: [
          {
            label: "名称",
            prop: "name",
          },
          {
            label: "区域",
            prop: "areaName",
          },
          {
            label: "编码",
            prop: "rtspKey",
          },
          {
            label: "机顶盒地址",
            prop: "stbUrl",
            width: "200px",
            type: "popover",
          },
          {
            label: "手机地址",
            prop: "phoneUrl",
            width: "200px",
            type: "popover",
          },
        ],
        rowButtons: {
          width: "200px",
          items: [
            {
              label: "编辑",
              fn: (data) => {
                this.ruleForm = data;
                this.title = "编辑";
                this.isEdit = true;
                this.dialogVisible = true;
              },
            },
            {
              label: "删除",
              type: "danger",
              fn: (data) => {
                this.$confirm("确认删除该rtsp模板?", "删除模板", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    this.$http.get(`${systemApi.rtspDel}/${data.id}`).then((res) => {
                      if (res.status === 200) {
                        this.$message({
                          type: "success",
                          message: "操作成功",
                        });
                        this.startSearch();
                      }
                    });
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "已取消操作",
                    });
                  });
              },
            },
          ],
        },
      },
      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      }, // 分页

      //formConfig
      ruleForm: {
        areaId: "",
        id: "",
        name: "",
        phoneUrl: "",
        rtspKey: "",
        stbUrl: "",
      },
      rules: {
        name: [
          {
            required: true,
            trigger: "change",
            message: "请输入平台名称",
          },
        ],
        rtspKey: [
          {
            required: true,
            trigger: "change",
            message: "请输入编码",
          },
        ],
        stbUrl: [
          {
            required: true,
            trigger: "change",
            message: "请输入机顶盒地址",
          },
        ],
        phoneUrl: [
          {
            required: true,
            trigger: "change",
            message: "请输入手机地址",
          },
        ],
      },
      formConfig: {
        disabled: false,
        ref: "rtspform",
        items: [
          [
            {
              valueType: "input", // 类型
              label: "名称",
              key: "name", // 数据名称
              prop: "name", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "100%",
              placeholder: "请输入名称", // 提示信息
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "编码",
              key: "rtspKey", // 数据名称
              prop: "rtspKey", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "100%",
              placeholder: "请输入编码", // 提示信息
            },
          ],
          [
            {
              valueType: "textarea", // 类型
              label: "机顶盒地址",
              key: "stbUrl", // 数据名称
              prop: "stbUrl", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "80%",
              rows: 3,
              maxlength: 500,
              placeholder: "请输入机顶盒地址", // 提示信息
            },
          ],
          [
            {
              valueType: "textarea", // 类型
              label: "手机地址",
              key: "phoneUrl", // 数据名称
              prop: "phoneUrl", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "80%",
              rows: 3,
              maxlength: 500,
              placeholder: "请输入手机地址", // 提示信息
            },
          ],
        ],
      },
      buttonConfig: {
        buttons: [
          {
            type: "save", // 保存
            loading: false,
            fn: (data) => {
              this.$http.post(systemApi.rtspSave, data).then((res) => {
                if (res.status == 200) {
                  this.$message.success(this.title + "成功！");
                  this.dialogVisible = false;
                  this.startSearch();
                }
              });
            },
          },
          {
            type: "back", // 重置
            fn: () => {
              this.dialogVisible = false;
            },
          },
        ],
      },
    };
  },
  methods: {
    changeSwitch(e) {
      this.switchVal = e;
      this.searchParams.isDown = e;
      this.isDown = e;
      this.startSearch();
    },
    // 每页显示条数
    sizeChange(size) {
      this.pagination.size = size;
      this.searchParams.size = size;
      this.startSearch();
    },
    // 当前页
    pageChange(page) {
      this.pagination.page = page;
      this.searchParams.page = page;
      this.startSearch();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    nodeClick(node) {
      this.searchParams.areaId = node.id;
      this.ruleForm.areaId = node.id;
      this.areaId = node.id;
      this.searchParams.page = this.pagination.page = 1;
      this.searchParams.size = this.pagination.size = 15;
      this.startSearch();
    },
    resetCallBack() {
      this.searchParams.page = this.pagination.page = 1;
      this.searchParams.size = this.pagination.size = 15;
      this.searchParams.search = "";
      this.searchParams.areaId = this.areaId;
      this.searchParams.isDown = this.isDown;
      this.startSearch();
    },
    startSearch() {
      this.$http
        .get(systemApi.rtspQueryListByPage, { params: this.searchParams })
        .then((res) => {
          if (res.status == 200) {
            this.tableTemplateData = res.result.pageList;
            this.pagination.total = res.result.total;
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.rtsp {
  margin-left: 10px;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
  display: flex;

  .left-tree {
    margin-right: 10px;
    border-right: 1px solid #c1c1c1;
  }

  .right-content {
	flex: 1;
	display: flex;
	flex-direction: column;
  }
}
</style>
